import { render } from "./RegistrationFieldSpecialty.vue?vue&type=template&id=5e1ea99a&scoped=true&ts=true"
import script from "./RegistrationFieldSpecialty.vue?vue&type=script&lang=ts"
export * from "./RegistrationFieldSpecialty.vue?vue&type=script&lang=ts"

import "./RegistrationFieldSpecialty.vue?vue&type=style&index=0&id=5e1ea99a&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1ea99a"]])

export default __exports__